import React, {useCallback, useMemo, useRef, useState} from 'react';
import {observer} from "mobx-react";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {MenuItemKey} from '../../../../services/configurations/config-data-sections/generated-config-const';
import {MenuItemComponentProps} from '../../../../services/menu-items-common/menu-item-component-props.interface';
import {UsefulLinksListBox} from '../../boxes/useful-links-list/useful-links-list.box';
import {UsefulLinkInnerItemComponent} from './useful-link-inner-item.component';
import {CyClass} from '../../../../../common/cy-classes';
import classNames from 'classnames';

interface ExpandableUsefulLinkitemComponentProps extends MenuItemComponentProps {
    subItems: MenuItemKey[];
    onSubItemClick?: () => void;
}

export const ExpandableUsefulLinkItemComponent: React.FC<ExpandableUsefulLinkitemComponentProps> = observer((props) => {
    const services = useServices();
    let [expanded, setExpanded] = useState(false);
    let subItems = useMemo(() => {
        return props.subItems
            .map((key) => services.userMenu.getUsefulLinkMenuItem(key))
            .filter((menuItem) => menuItem.display);
    }, [props.subItems, services]);

    const onClickHandler = useCallback(() => {
        // For expandable, don;t use "props.menuItem.execute();" we don't want to navigate and we don't want to close the user menu
        setExpanded((currentValue) => !currentValue);
    }, []);

    let height = useRef((subItems.length * 3.75) + "rem");
    const onLinksListBoxCaptureRef = useCallback((el: HTMLElement | null) => {
        if (el) {
            const heightCssVal = el.style.height;
            el.style.height = "auto";
            const rect = el.getBoundingClientRect();
            height.current = rect.height + "px";
            el.style.height = heightCssVal;
        }
    }, []);

    if (subItems.length === 0) {
        return null;
    }

    if (subItems.length === 1) {
        return subItems[0].renderMenuItem({onBeforeClick: props.onSubItemClick, showSeparator: props.showSeparator});
    }

    return <UsefulLinkInnerItemComponent
        onClick={onClickHandler}
        {...props}
        expandedArrowIcon={expanded}
        className={classNames(props.className, CyClass("cy-useful-links-item-expandable"))}
    >
        <UsefulLinksListBox className={CyClass('cy-useful-links-sub-items-list')} style={{
            transition: "height 0.12s ease-out",
            height: expanded ? height.current : "0",
            overflow: "hidden"
        }} ref={onLinksListBoxCaptureRef}>
            { subItems.map((menuItem) => menuItem.renderMenuItem({onBeforeClick: props.onSubItemClick, showSeparator: false, className: CyClass('cy-useful-links-subitem')})) }
        </UsefulLinksListBox>
    </UsefulLinkInnerItemComponent>

});